// Moved out of login.tsx (page) so that the middleware can import it without importing 300 KB with it.
export const loginPageName = 'login';

// Appartenance produit (B0_02b) : produit émetteur du forum, envoyé via le header `semio-product`
// sur les requêtes GraphQL → l'API marque `first_connected.graphdebate`. Doit matcher la whitelist
// API (`['graphcomment','graphdebate']`). Constante centralisée : une typo ferait un no-op silencieux
// côté API (pas d'erreur), donc on évite de répéter le littéral sur chaque call-site.
export const SEMIO_PRODUCT = 'graphdebate' as const;
